import React from "react";
import { SearchIcon } from "lucide-react";
import { currentCompanyLinks, currentSports, currentAgeGroups } from "../data/navigation";
import { NoteTag } from "./NoteTag";
type CurrentAboutMenuProps = {
  showNotes: boolean;
};
function ColumnHeading({
  children
}: {
  children: React.ReactNode;
}) {
  return <h3 className="font-display text-lg font-extrabold uppercase italic tracking-wider" data-id="element-17" data-mp="gthjrp0hn87p">{children}</h3>;
}
export function CurrentAboutMenu({
  showNotes
}: CurrentAboutMenuProps) {
  const outOfScope = showNotes ? "outline-dashed outline-2 outline-offset-8 outline-i9-note/80" : "";
  return <div className="relative bg-i9-blue pb-12 text-white shadow-[0_24px_48px_-16px_rgba(22,21,74,0.55)]" data-id="element-18" data-mp="3p8rs3euz19nx">
      <div className="grid grid-cols-4 gap-8 px-9 pt-9" data-id="element-19" data-mp="3u8e27ffi69si">
        <div data-id="element-20" data-mp="3u5rosz5xl02d">
          <ColumnHeading data-id="element-21" data-mp="14j2d91u9pnv8">Company</ColumnHeading>
          <ul className="mt-4 space-y-3.5" data-id="element-22" data-mp="14iagvosujm3w">
            {currentCompanyLinks.map(l => {
            const dim = showNotes && l.status === "moved";
            return <li key={l.label} className="flex flex-col items-start gap-1" data-id="element-23" data-mp="2tzi6xfr925ln">
                  <a href="#" className={`text-[16px] hover:underline ${dim ? "text-white/50 line-through decoration-i9-note" : ""}`} data-id="element-24" data-mp="2pyetezwoclnl">
                    {l.label}
                  </a>
                  {showNotes && l.note && <NoteTag data-id="element-25" data-mp="2g1jsybgucb6o">{l.note}</NoteTag>}
                </li>;
          })}
          </ul>
        </div>

        <div className={outOfScope} data-id="element-26" data-mp="2b2gy1jukrlcf">
          <div className="flex items-center gap-2" data-id="element-27" data-mp="2b3i9hpfi69uo">
            <ColumnHeading data-id="element-28" data-mp="26a5pjslrqr89">Sports We Play</ColumnHeading>
          </div>
          {showNotes && <NoteTag className="mt-1" data-id="element-29" data-mp="228kduakz0izn">Moves to Programs</NoteTag>}
          <ul className="mt-4 space-y-3" data-id="element-30" data-mp="1xa98ac1pkun8">
            {currentSports.map(s => <li key={s} className="flex items-center gap-3" data-id="element-31" data-mp="1x8fy4mrvzsah">
                <span className="h-6 w-6 shrink-0 rounded-full border-2 border-white/60" aria-hidden="true" data-id="element-32" data-mp="1s9uyopkglcn3" />
                <a href="#" className="text-[16px] hover:underline" data-id="element-33" data-mp="1ncmobb5jycwe">{s}</a>
              </li>)}
          </ul>
        </div>

        <div className={`self-start ${outOfScope}`} data-id="element-34" data-mp="1ink8e93jofgb">
          <ColumnHeading data-id="element-35" data-mp="1iod6ymscnynd">Programs</ColumnHeading>
          {showNotes && <NoteTag className="mt-1" data-id="element-36" data-mp="14oatdcr2rrdx">Moves to Programs</NoteTag>}
          <ul className="mt-4 space-y-3" data-id="element-37" data-mp="14pvq990v3mey">
            {currentAgeGroups.map(g => <li key={g.code} className="flex items-center gap-3" data-id="element-38" data-mp="18pnytlq99skb">
                <span className="flex h-7 w-7 items-center justify-center border border-white text-[11px] font-bold" style={{
              backgroundColor: g.color
            }} aria-hidden="true" data-id="element-39" data-mp="1wg06cvhl9nad">
                  {g.code}
                </span>
                <a href="#" className="text-[16px] hover:underline" data-id="element-40" data-mp="1rn6za0yne2v4">{g.label}</a>
              </li>)}
          </ul>
        </div>

        <div className={`self-start ${outOfScope}`} data-id="element-41" data-mp="2fbq7kghp6fn7">
          <ColumnHeading data-id="element-42" data-mp="2k4t7d6d2ilbu">Find a Program Near You</ColumnHeading>
          {showNotes && <NoteTag className="mt-1" data-id="element-43" data-mp="8pas0oqqns5z">Duplicates top-bar search</NoteTag>}
          <div className="mt-4 flex" data-id="element-44" data-mp="8n7qp8k4ycly">
            <input aria-label="ZIP code" defaultValue="33578" className="h-11 w-full min-w-0 border border-white bg-white px-3 text-i9-ink" data-id="element-45" data-mp="3r98k2pehqtz" />
            <button className="flex h-11 shrink-0 items-center gap-1.5 bg-i9-red px-3 text-sm font-semibold" data-id="element-46" data-mp="dfr6mc6apjtx">
              <SearchIcon className="h-4 w-4" data-id="element-47" data-mp="3lvawr2bo6m4r" /> Find
            </button>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-10 bg-i9-ink" style={{
      clipPath: "polygon(40% 100%, 100% 10%, 100% 100%)"
    }} aria-hidden="true" data-id="element-48" data-mp="3gyayhdl2ano7" />
    </div>;
}